/**
 * @enum {String}
 */
export const SearchSourceType = {
    /**
     * 进入页面触发搜索
     */
    DEFAULT_SEARCH: "default_search_change",
    /**
     * 来源至changeImmutable
     */
    CHANGE_IMMUTABLE_SEARCH_CHANGE: "change_immutable_search_change",
    /**
     * 单个组件触发搜索
     */
    SINGLE_CONTROL: "single_control",
    /**
     * 搜索按钮触发搜索
     */
    SEARCH_BUTTON: "search_button",
    /**
     * 重置按钮触发搜索
     */
    RESET_BUTTON: "reset_button",
    /**
     * 设置默认参数触发搜索
     */
    METHOD_SET_DEFAULT_SEARCH_PARAM: "method_set_default_search_param",
    /**
     * 设置搜索参数触发搜索
     */
    METHOD_SET_SEARCH_PARAM: "method_set_search_param",
};
